import { useEffect, useState } from "react";
import Col from 'react-bootstrap/Col';
import styles from '../../styles/ListView.module.css';
import Link from "next/link";
import * as LIB from '../../lib/common';
import { commonUrl } from '../api/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from "@fortawesome/free-brands-svg-icons"

const PlayList = ({ size }) => {
    const [playlist, setPlaylist] = useState([]);
    const youtubeIcon = <FontAwesomeIcon icon={faYoutube} className={styles.playlistIcon} />;

    useEffect(() => {
        //fetch playlist data
        fetchPlaylist();

    }, []);

    const fetchPlaylist = async () => {
        // fetch youtube play list data
        let url = commonUrl.musicPlaylist;
        const res = await fetch(url, { method: 'GET' });
        const playlistData = await res.json();

        console.log('playlistData=', playlistData);

        if (playlistData) {
            setPlaylist(playlistData);
        }
    }

    if (playlist) {
        let rows = [];
        let l = 0;
        while (l < playlist.length) {
            let item = playlist[l];
            let url = `https://www.youtube.com/playlist?list=${item.id}`;
            if (item.id == 'bttm') {
                //catch the exception
                url = 'https://www.youtube.com/c/BackToTheMusic/videos';
            }

            rows.push(
                <a href={url} target='_blank' key={l} className={styles.playlistAtag}>
                    <div className={styles.playlistRow}>
                        {youtubeIcon}
                        <span className={styles.playlistTitle}>{item.title}</span>
                    </div>
                </a>
            );
            l++;
        }

        if (size == 'lg') {
            return (
                <Col lg={3} md={4} className={`d-none d-lg-block d-md-block d-sm-none ${styles.col}`}>
                    <div className={styles.playlistHolder}>
                        <div className={styles.playlistHeader}>YouTube 播放清單</div>
                        <div className={styles.relatedDivider}></div>
                        {rows}
                    </div>
                </Col>
            );
        }
        else if (size == 'sm') {
            return (
                <Col lg={3} md={4} xs={12} className={`d-block d-md-none ${styles.col}`}>
                    <div className={styles.playlistHolder}>
                        <div className={styles.playlistHeader}>YouTube 播放清單：</div>
                        <div className={styles.relatedDivider}></div>
                        {rows}
                    </div>
                </Col>
            );
        }
    }

    return <></>;
}

export default PlayList;